import { render, staticRenderFns } from "./LogosIcon.vue?vue&type=template&id=eecc8ffe&"
import script from "./LogosIcon.vue?vue&type=script&lang=js&"
export * from "./LogosIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports